if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.submitButton = this.querySelector('.product-card-new__add-button') || this.querySelector('[type="submit"]');
        this.clickCount = 0; // Contador de clics
        this.productId = this.form?.querySelector('[name="id"]')?.value || 'unknown';
        
        // Vincular submit del formulario
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this), { capture: false });
        
        // CRÍTICO: Vincular click directo y ejecutar submit inmediatamente
        if (this.submitButton) {
          this.submitButton.addEventListener('click', (e) => {
            this.clickCount++;
            const isLoading = this.submitButton.classList.contains('loading');
            
            console.log('%c🖱️ CLICK #' + this.clickCount + ' detectado', 
              'background: #2196F3; color: white; padding: 2px 4px; border-radius: 2px; font-weight: bold;', 
              {
                productId: this.productId,
                isLoading: isLoading,
                timestamp: new Date().toISOString().split('T')[1],
                buttonElement: this.submitButton.id || 'no-id'
              }
            );
            
            // Si ya está loading, prevenir inmediatamente
            if (isLoading) {
              console.log('%c⛔ BLOQUEADO', 'background: #f44336; color: white; padding: 2px 4px; border-radius: 2px;', 
                'Ya está en loading, ignorando click #' + this.clickCount);
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            
            console.log('%c✅ PERMITIDO', 'background: #4CAF50; color: white; padding: 2px 4px; border-radius: 2px;', 
              'Click #' + this.clickCount + ' ejecutará submit AHORA');
            
            // Prevenir el submit nativo para controlarlo nosotros
            e.preventDefault();
            e.stopPropagation();
            
            // Ejecutar submit handler INMEDIATAMENTE
            this.onSubmitHandler(e);
          }, { capture: true });
        }
        
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        
        console.log('%c🎯 ProductForm inicializado', 'background: #222; color: #bada55; padding: 2px 4px; border-radius: 2px;', {
          productId: this.productId,
          buttonId: this.submitButton?.id || 'no-id'
        });
      }
      
      getCart() {
        // Siempre buscar el cart dinámicamente para asegurar que existe
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      onSubmitHandler(evt) {
        console.log('%c📤 SUBMIT HANDLER ejecutado', 
          'background: #FF9800; color: white; padding: 2px 4px; border-radius: 2px; font-weight: bold;', 
          {
            productId: this.productId,
            clickCount: this.clickCount,
            timestamp: new Date().toISOString().split('T')[1]
          }
        );
        
        // Si ya está cargando, prevenir y salir inmediatamente
        if (this.submitButton.classList.contains('loading')) {
          console.log('%c⛔ SUBMIT BLOQUEADO', 'background: #f44336; color: white; padding: 2px 4px; border-radius: 2px;', 
            'Ya está en loading');
          evt.preventDefault();
          return;
        }

        console.log('%c✅ SUBMIT ACEPTADO', 'background: #4CAF50; color: white; padding: 2px 4px; border-radius: 2px;', 
          'Procesando agregado al carrito...');
        evt.preventDefault();
        this.handleErrorMessage();

        // Estado visual INSTANTÁNEO - aplicar todas las clases al mismo tiempo
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-disabled', true);
        console.log('%c🔄 Estado LOADING aplicado', 
          'background: #9C27B0; color: white; padding: 2px 4px; border-radius: 2px;', 
          'después de ' + this.clickCount + ' click(s)');
        
        // Configuración del tema
        const loadingText = window.theme?.settings?.product_card_add_button_loading_text || 'Agregando...';
        const hideIcon = window.theme?.settings?.product_card_hide_icon_on_loading !== false;
        
        // Manejo del icono y texto
        const icon = this.submitButton.querySelector('.product-card-new__add-icon');
        const text = this.submitButton.querySelector('.product-card-new__add-text');
        
        // Guardar texto original si no está guardado
        if (text && !text.dataset.originalText) {
          text.dataset.originalText = text.textContent;
        }
        
        // Transición suave: primero desvanecer
        if (text) {
          text.style.opacity = '0';
        }
        if (hideIcon && icon) {
          icon.style.opacity = '0';
        }
        
        // Cambiar texto después de la transición
        setTimeout(() => {
          if (text) {
            text.textContent = loadingText;
            text.style.opacity = '1';
          }
        }, 150); // Esperar a que termine la transición de desvanecimiento

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const cart = this.getCart();
        
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              const textElement = this.submitButton.querySelector('.product-card-new__add-text') || 
                                 this.submitButton.querySelector('span');
              if (textElement) textElement.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            
            // Buscar el cart dinámicamente
            const cart = this.getCart();
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error('❌ ERROR en agregado al carrito:', {
              productId: this.productId,
              error: e.message,
              timestamp: new Date().toISOString().split('T')[1]
            });
            console.error(e);
          })
          .finally(() => {
            console.log('%c✅ PROCESO COMPLETADO', 
              'background: #4CAF50; color: white; padding: 2px 4px; border-radius: 2px; font-weight: bold;', 
              {
                productId: this.productId,
                totalClicks: this.clickCount,
                timestamp: new Date().toISOString().split('T')[1]
              }
            );
            
            // Restaurar estado
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            
            // Restaurar contenido original con transición suave
            const icon = this.submitButton.querySelector('.product-card-new__add-icon');
            const text = this.submitButton.querySelector('.product-card-new__add-text');
            
            // Primero desvanecer
            if (text) {
              text.style.opacity = '0';
            }
            
            // Luego cambiar texto y restaurar
            setTimeout(() => {
              if (text) {
                text.textContent = text.dataset.originalText || 'Agregar';
                text.style.opacity = '1';
              }
              if (icon) {
                icon.style.opacity = '1';
              }
            }, 150);
            
            const finalCart = this.getCart();
            if (finalCart && finalCart.classList.contains('is-empty')) finalCart.classList.remove('is-empty');

            console.log('%c🔓 Botón desbloqueado', 
              'background: #00BCD4; color: white; padding: 2px 4px; border-radius: 2px;', 
              'Listo para nuevo agregado');
            console.log('%c═══════════════════════════════════════════════════', 
              'color: #999;');
            console.log(' ');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) {
            const textElement = this.submitButton.querySelector('.product-card-new__add-text') || 
                               this.submitButton.querySelector('span');
            if (textElement) textElement.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
